export default function (fun, delay) {
  let timer = null;
  return function() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fun.apply(this, arguments);
    }, delay);
  };
}

export function formatterSize(size) {
  const sizeArray = size.split(',')
  const sortedArr = sizeArray.sort((a, b) => a - b);
  const textArray =  ['Small', 'Medium','Large']
  const newText = sortedArr.map((item) => {return textArray[item - 1]})
  return newText.join(',')
}
